import { MutationHookOptions, useMutation } from '@apollo/client';

import {
  CancelTeamMemberRequestDocument,
  CancelTeamMemberRequestMutation,
  CancelTeamMemberRequestMutationVariables,
} from './cancelTeamMemberRequest.gql';

export type CancelTeamMemberRequestOptions = Omit<
  MutationHookOptions<
    CancelTeamMemberRequestMutation,
    CancelTeamMemberRequestMutationVariables
  >,
  'variables'
>;

export const useCancelTeamMemberRequest = (
  input: CancelTeamMemberRequestMutationVariables['input'],
  options?: CancelTeamMemberRequestOptions,
) => {
  return useMutation(CancelTeamMemberRequestDocument, {
    ...options,
    variables: {
      input,
    },
  });
};
